import { Component, Input } from '@angular/core';
import { AppConfigService } from '../../../app-config.service';

@Component({
  selector: 'app-currency-string',
  templateUrl: './currency-string.component.html',
  styleUrls: ['./currency-string.component.scss'],
  standalone: false
})
export class CurrencyStringComponent {
  @Input()
  value: number | string;
  @Input()
  id?: string;
  @Input() periodicity: string;
  @Input()
  animation?: string;

  private readonly _appConfigService: AppConfigService;

  constructor(appConfigService: AppConfigService) {
    this._appConfigService = appConfigService;
    this.animation = '';
  }

  get locale() {
    return this._appConfigService.configData.contexteEnvironnement.langue === 'fr' ? 'fr' : 'en';
  }

  get countUpAnimationOptions() {
    return this.locale === 'fr'
      ? { duration: 2, separator: ' ', suffix: ' $' }
      : { duration: 2, separator: ',', suffix: '$' };
  }
}
